import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { uint8_type, record_type, bool_type, class_type, string_type, option_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class DbFeeChangeBeforeAfter extends Record {
    constructor(AccountNo, BilledTo, BilledToSynced, BoundMonths, BoundTo, CancelledAtDate, CancelledAtUtc, CancelledBy, CancelledDate, CancellationPeriodMonths, CategoryId, ClientNr, ClientsCrossReference, ClientSalesNr, ContractNr, CreatedBy, CreatedDate, CurrentState, Description, EndDate, EarliestInvoiceDate, Fee, FeeInclVat, FeeNr, FeeTemplateNr, FeeType, MonthsInAdvance, NextBillFrom, Obliterated, Period, PeriodDesc, PreparedForBilling, SortOrder, StartDate, UnitPrice, Units, UpdatedBy, VatRatePercent, EndUser, NoNextInvoice, BoundToDate, ContractStartDate, _CreatedBy) {
        super();
        this.AccountNo = AccountNo;
        this.BilledTo = BilledTo;
        this.BilledToSynced = BilledToSynced;
        this.BoundMonths = BoundMonths;
        this.BoundTo = BoundTo;
        this.CancelledAtDate = CancelledAtDate;
        this.CancelledAtUtc = CancelledAtUtc;
        this.CancelledBy = CancelledBy;
        this.CancelledDate = CancelledDate;
        this.CancellationPeriodMonths = CancellationPeriodMonths;
        this.CategoryId = CategoryId;
        this.ClientNr = ClientNr;
        this.ClientsCrossReference = ClientsCrossReference;
        this.ClientSalesNr = ClientSalesNr;
        this.ContractNr = ContractNr;
        this.CreatedBy = CreatedBy;
        this.CreatedDate = CreatedDate;
        this.CurrentState = CurrentState;
        this.Description = Description;
        this.EndDate = EndDate;
        this.EarliestInvoiceDate = EarliestInvoiceDate;
        this.Fee = Fee;
        this.FeeInclVat = FeeInclVat;
        this.FeeNr = FeeNr;
        this.FeeTemplateNr = FeeTemplateNr;
        this.FeeType = FeeType;
        this.MonthsInAdvance = MonthsInAdvance;
        this.NextBillFrom = NextBillFrom;
        this.Obliterated = Obliterated;
        this.Period = Period;
        this.PeriodDesc = PeriodDesc;
        this.PreparedForBilling = PreparedForBilling;
        this.SortOrder = SortOrder;
        this.StartDate = StartDate;
        this.UnitPrice = UnitPrice;
        this.Units = Units;
        this.UpdatedBy = UpdatedBy;
        this.VatRatePercent = VatRatePercent;
        this.EndUser = EndUser;
        this.NoNextInvoice = NoNextInvoice;
        this.BoundToDate = BoundToDate;
        this.ContractStartDate = ContractStartDate;
        this._CreatedBy = _CreatedBy;
    }
}

export function DbFeeChangeBeforeAfter$reflection() {
    return record_type("Containers.ContractHistory.Model.DbFeeChangeBeforeAfter", [], DbFeeChangeBeforeAfter, () => [["AccountNo", option_type(int32_type)], ["BilledTo", option_type(string_type)], ["BilledToSynced", option_type(string_type)], ["BoundMonths", option_type(int32_type)], ["BoundTo", option_type(string_type)], ["CancelledAtDate", option_type(string_type)], ["CancelledAtUtc", option_type(string_type)], ["CancelledBy", option_type(string_type)], ["CancelledDate", option_type(string_type)], ["CancellationPeriodMonths", option_type(int32_type)], ["CategoryId", option_type(string_type)], ["ClientNr", option_type(int32_type)], ["ClientsCrossReference", option_type(string_type)], ["ClientSalesNr", option_type(int32_type)], ["ContractNr", option_type(int32_type)], ["CreatedBy", option_type(string_type)], ["CreatedDate", option_type(string_type)], ["CurrentState", option_type(string_type)], ["Description", option_type(string_type)], ["EndDate", option_type(string_type)], ["EarliestInvoiceDate", option_type(string_type)], ["Fee", option_type(class_type("System.Decimal"))], ["FeeInclVat", option_type(class_type("System.Decimal"))], ["FeeNr", option_type(int32_type)], ["FeeTemplateNr", option_type(int32_type)], ["FeeType", option_type(int32_type)], ["MonthsInAdvance", option_type(int32_type)], ["NextBillFrom", option_type(string_type)], ["Obliterated", option_type(bool_type)], ["Period", option_type(int32_type)], ["PeriodDesc", option_type(string_type)], ["PreparedForBilling", option_type(bool_type)], ["SortOrder", option_type(int32_type)], ["StartDate", option_type(string_type)], ["UnitPrice", option_type(class_type("System.Decimal"))], ["Units", option_type(int32_type)], ["UpdatedBy", option_type(int32_type)], ["VatRatePercent", option_type(class_type("System.Decimal"))], ["EndUser", option_type(string_type)], ["NoNextInvoice", option_type(bool_type)], ["BoundToDate", option_type(string_type)], ["ContractStartDate", option_type(string_type)], ["_CreatedBy", option_type(int32_type)]]);
}

export class DbFeeChangeContainer extends Record {
    constructor(After, Before, FeeNr) {
        super();
        this.After = After;
        this.Before = Before;
        this.FeeNr = FeeNr;
    }
}

export function DbFeeChangeContainer$reflection() {
    return record_type("Containers.ContractHistory.Model.DbFeeChangeContainer", [], DbFeeChangeContainer, () => [["After", DbFeeChangeBeforeAfter$reflection()], ["Before", DbFeeChangeBeforeAfter$reflection()], ["FeeNr", option_type(int32_type)]]);
}

export class NumberChange extends Record {
    constructor(Number$, ChangeAtUtc, NetworkContractNr, NumberChangeId, UserId, User, ChangeType, ParameterJson) {
        super();
        this.Number = Number$;
        this.ChangeAtUtc = ChangeAtUtc;
        this.NetworkContractNr = NetworkContractNr;
        this.NumberChangeId = (NumberChangeId | 0);
        this.UserId = (UserId | 0);
        this.User = User;
        this.ChangeType = ChangeType;
        this.ParameterJson = ParameterJson;
    }
}

export function NumberChange$reflection() {
    return record_type("Containers.ContractHistory.Model.NumberChange", [], NumberChange, () => [["Number", string_type], ["ChangeAtUtc", class_type("System.DateTime")], ["NetworkContractNr", uint8_type], ["NumberChangeId", int32_type], ["UserId", int32_type], ["User", string_type], ["ChangeType", string_type], ["ParameterJson", string_type]]);
}

export class ContractEvent extends Record {
    constructor(AtUtc, UserId, Username, EventName, EventArgs) {
        super();
        this.AtUtc = AtUtc;
        this.UserId = (UserId | 0);
        this.Username = Username;
        this.EventName = EventName;
        this.EventArgs = EventArgs;
    }
}

export function ContractEvent$reflection() {
    return record_type("Containers.ContractHistory.Model.ContractEvent", [], ContractEvent, () => [["AtUtc", class_type("System.DateTimeOffset")], ["UserId", int32_type], ["Username", string_type], ["EventName", string_type], ["EventArgs", string_type]]);
}

